<button
  (click)="buttonClick.emit($event)"
  class="bg-white icon icon-arrow-down-s text-primary-600 rounded-full p-3.5 p-3.5"
></button>
